<ng-container >
  <main role="main" class="main-container">
    <app-header></app-header>
    <div id="content-container">
      <div id="check-route" [routerLink]="['/login']" routerLinkActive="out"></div>
      <div class="main-menu-container" [hidden]="!globals.isMenuOpen">
        <app-main-menu></app-main-menu>
      </div>
      <div class="main-content-container">
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>
</ng-container>
